<template>
  <div class="spe_list">
    <div class="theme-list">
      <div class="classify">
        <div class="keyword-input">
          <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
        </div>
        <div class="options">
          <ul class="classify-ul">
            <li :class="{active: theme_params.theme_type_id == ''}">
              <a class="new">
                <span @click="handleChangeThemeType('')">最新</span>
                <img v-show="is_new" :src="$store.state.static_img_url+'pic/logo_w.png'" alt="动脉橙" @click="haddleApplyTry2(32)">
                <img v-show="!is_new" :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙" @click="haddleApplyTry2(32)">
              </a>
            </li>
            <li v-for="item,index in theme_type" :key="index" :class="{show: showKids(item.id)}" v-if="item.kids.length > 0">
              <a @click="handleShowKids(item.id)">
                {{item.name}}
                <i class="iconfont">
                  <template v-if="showKids(item.id)">&#xe63b;</template>
                  <template v-else>&#xe648;</template>
                </i>
              </a>

              <ul class="sec-ul" v-show="showKids(item.id)">
                <li v-for="item2,index2 in item.kids" :key="index2" :class="{active: theme_params.theme_type_id == item2.id}">
                  <a @click="handleChangeThemeType(item2.id)">{{item2.name}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="list">
        <div class="list-top" v-if="theme_params.theme_type_id || theme_params.keyword">
          <p class="s-tip">关于<span>{{theme_params.theme_type_id | deal('theme_type', 'name', '')}}<i v-if="theme_params.theme_type_id && theme_params.keyword">与</i>{{theme_params.keyword}}</span>的专题</p>
          <div class="sel_clear">
            <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
          </div>
        </div>
        <div class="scientific" v-if="!theme_params.theme_type_id && !theme_params.keyword && show_scientific">
          <i class="iconfont" @click="haddleCloseScientific">&#xe6bb;</i>
          <img @click="haddleClickScientific" :src="$store.state.static_img_url + 'pic/scientific-banner.png'" />
        </div>
        <div class="pay-notes" v-if="themeTypeState">
          <p><i class="iconfont">&#xe654;</i>购买须知</p>
          <i :class="{'iconfont': true, 'on': show_notes}" @click="show_notes=!show_notes">&#xe63b;</i>
          <div class="notes-cnt" v-show="show_notes">
            1、此内容需付费，单篇专题付费后，附赠解锁{{theme_params.theme_type_id | deal('theme_type', 'name', '')}}所有专题，平台VIP会员免费查看；
            <br>2、本专栏购买成功后一年内有效；
            <br>3、本专栏为虚拟内容服务，一经购买成功概不退款，请您理解；
            <br>4、购买后，可从【个人中心-已购产品】中查看已购买的专栏；
            <br>5、《{{theme_params.theme_type_id | deal('theme_type', 'name', '')}}》内容为动脉橙平台所有。
          </div>
        </div>

        <ul class="spe_ul2 clear">
          <li v-for="item,index in re_theme_list" :key="'t' + index" v-if="theme_params.theme_type_id == '' && !search_ipt" @click="goDetail(item)">
            <div>
              <div class="logo">
                <img :src="img_req_url + item.share_logo_path" />
                <img :src="$store.state.static_img_url + 'pic/tj_tag.png'" class="r-tip">
              </div>
              <div class="spe_info">
                <p class="p1">{{item.title}}</p>
                <p class="p2" v-if="item.latest_content && item.latest_content.length > 0">
                  <span>{{item.update_time | time_standard}}更新</span>
                  <span>{{item.latest_content[0].title}}</span>
                </p>
              </div>
            </div>
            <!-- <img :src="$store.state.static_img_url + 'pic/vip_tag.png'" class="vip-sp" v-if="item.only_vip == '1'"> -->
            <img :src="$store.state.static_img_url + 'pic/vip_tag.png'" class="vip-sp" v-if="themeState(item) == 1">
            <img :src="$store.state.static_img_url + 'pic/pay_tag.png'" class="vip-sp" v-if="themeState(item) == 2">
            <img :src="$store.state.static_img_url + 'pic/pay_tag2.png'" class="vip-sp" v-if="themeState(item) == 3">
          </li>
          <li v-for="item,index in theme_list" :key="index" @click="goDetail(item)">
            <div>
              <div class="logo">
                <img :src="img_req_url + item.share_logo_path" class="loge-img" />
              </div>
              <div class="spe_info">
                <p class="p1">{{item.title}}</p>
                <p class="p2" v-if="item.latest_content && item.latest_content.length > 0">
                  <span>{{item.update_time | time_standard}}更新</span>
                  <span>{{item.latest_content[0].title}}</span>
                </p>
                <!-- <p class="p3">{{item.summary}}</p> -->
              </div>
            </div>
            <img :src="$store.state.static_img_url + 'pic/vip_tag.png'" class="vip-sp" v-if="themeState(item) == 1">
            <img :src="$store.state.static_img_url + 'pic/pay_tag.png'" class="vip-sp" v-if="themeState(item) == 2">
            <img :src="$store.state.static_img_url + 'pic/pay_tag2.png'" class="vip-sp" v-if="themeState(item) == 3">
          </li>
        </ul>
        <div class="list_bottom">
          <button class="more_btn" @click="haddleMore" v-if="len == 12">加载更多</button>
        </div>
        <!-- <p v-if="len == 0 && !is_more && list_loading3" class="no-tip">没有相关专题</p> -->
        <Nothing v-if="len == 0 && !list_loading1 && !list_loading2 && !list_loading3 && !is_more">
          <p>没有相关专题</p>
        </Nothing>
        <div class="loading_bg" v-if="list_loading3">
          <Spin fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
        <Spin fix v-if="list_loading1 || list_loading2">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
    </div>
    <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
  </div>
</template>
<script>
import { recommendThemeList, themeList, addPuv, getUserPayThemeType } from '../../service'
import { userInfo } from 'js/userInfo'
import { left_scroll } from 'js/left_scroll'
import Nothing from '@/components/Nothing2.vue'
import VipPrompt from '@/components/VipPrompt.vue'
import filter from 'js/filter'
export default {
  mixins: [userInfo, left_scroll],
  inject: ['reload', 'login', 'haddleApplyTry2', 'globalInsertRecords'],
  components: {
    Nothing,
    VipPrompt,
  },
  data() {
    return {
      filter: filter,
      list_loading1: true,
      list_loading2: true,
      list_loading3: true,
      re_theme_list: [],
      theme_list: [],
      theme_params: {
        theme_type_id: '',
        page: 1,
        keyword: '',
        // only_vip: 0
      },
      is_more: false, //是否更多
      len: 0,
      show_kids: [],
      page_modal: false,
      show_notes: true,
      search_ipt: '',
      search_phd: '',
      pay_theme_type: [],
      show_scientific: true,
      is_new: true,
    }
  },
  computed: {
    img_req_url() {
      return this.$store.state.img_req_url
    },
    theme_type_old() {
      return this.$store.state.theme_type
    },
    theme_type() {
      if (!this.$store.state.theme_type) {
        return []
      } else {
        let arr = []
        for (let i of this.$store.state.theme_type) {
          if (i.pid == null) {
            i.kids = this.$store.state.theme_type.filter((item) => item.pid == i.id)
            arr.push(i)
          }
        }
        return arr
      }
    },
    active() {
      return this.$route.query.active
    },
    /**
     * 当前专题是否付费
     */
    themeTypeState() {
      let theme_type_list = this.$store.state.theme_type
      let index = theme_type_list.findIndex((a) => this.theme_params.theme_type_id == a.id)
      if (index > -1) {
        return theme_type_list[index].price > 0
      } else {
        return false
      }
    },
    /**
     * 专题桩体（免费0、会员专享1、付费解锁2、已购买3）
     *  theme_id专题ID type专题类型
     */
    themeState() {
      return function (theme_item) {
        let theme_type_list = this.$store.state.theme_type
        if (theme_item.type_arr.length > 0) {
          let type_item = theme_type_list.find((a) => theme_item.type_arr[0] == a.id)
          if (type_item) {
            if (type_item.price > 0 && theme_item.price > 0) {
              if (this.user_key) {
                if (this.isVIP) {
                  return 1
                } else {
                  let i = this.pay_theme_type.findIndex(
                    (a) => a.theme_type_id == theme_item.type_arr[0]
                  )
                  if (i > -1) {
                    return 3
                  } else {
                    return 2
                  }
                }
              } else {
                return 2
              }
            } else {
              return 0
            }
          } else {
            return 0
          }
        } else {
          return 0
        }
      }
    },
    default_key() {
      let index = this.$store.state.datahotsearchkey.findIndex((a) => a.position_id == '17'),
        key = ''
      if (index > -1) {
        key = this.$store.state.datahotsearchkey[index].name
      }
      return key
    },
  },
  methods: {
    async getRecommendTheme() {
      let res = await recommendThemeList(
        {
          size: '3',
          position_id: '2',
          latest_size: '1',
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 're_theme_list', res.res)
        this.list_loading1 = false
      } else {
        this.$Message.error(res.message)
      }
    },
    async getThemeList() {
      this.len = 0
      // this.theme_params.only_vip = this.theme_params.theme_type_id === '' ? 0 : ''
      let res = await themeList(this.theme_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        // this.$route.query.type = this.theme_params.theme_type_id

        res.res.map((a) => {
          this.theme_list.push(a)
        })
        this.len = res.res.length

        this.list_loading2 = false
        this.list_loading3 = false
        this.list_loading4 = false
        this.$nextTick(() => this.listenerScroll('options'), 12)
        if (this.len == 0 && this.is_more) {
          this.$Message.warning('数据已加载完，没有更多了')
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    async getUserPayThemeType() {
      let res = await getUserPayThemeType(
        {
          user_key: this.user_key,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'pay_theme_type', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
    haddleMore() {
      this.is_more = true
      this.theme_params.page++
      this.getThemeList()
    },
    goDetail(item) {
      this.globalInsertRecords({
        content_type: 88,
        enter_type: 48,
        view_type: 1,
        content_id: item.id,
        keyword: 3
      })
      const { href } = this.$router.resolve({ name: 'SpecialDetail', params: { uid: item.uid } })
      window.open(href, '_blank')
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: '',
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    /**
     * 改变专题类型
     * type_id 类型id 选择最新时为null
     */
    handleChangeThemeType(type_id) {
      if (type_id === '') {
        this.is_new = true
        _czc.push(['_trackEvent', '专题列表页', '主题一级点击（最新）'])
        this.$router.push({ name: 'SpecialList', query: {} })
      } else {
        this.is_new = false
        let item = this.theme_type_old.find((a) => a.id == type_id)
        _czc.push([
          '_trackEvent',
          '专题列表页',
          '主题二级点击（' +
            filter.deal(item.pid, 'theme_type') +
            '_' +
            filter.deal(type_id, 'theme_type') +
            '）',
        ])
        this.$router.push({ name: 'SpecialList', query: { active: type_id } })
      }
      this.theme_params.theme_type_id = type_id
      this.theme_params.page = 1

      if (!type_id) {
        this.list_loading2 = true
        this.list_loading3 = false
      } else {
        this.list_loading3 = true
      }
      this.theme_list = []
      this.is_more = false
      this.show_notes = true
      this.getThemeList()
    },
    /**
     * 展开二级分类
     */
    handleShowKids(item_id) {
      _czc.push([
        '_trackEvent',
        '专题列表页',
        '主题一级点击（' + filter.deal(item_id, 'theme_type') + '）',
      ])
      let index = this.show_kids.findIndex((a) => a == item_id)
      if (index > -1) {
        this.show_kids.splice(index, 1)
      } else {
        this.show_kids.push(item_id)
      }
    },
    showKids(item_id) {
      return this.show_kids.findIndex((a) => a == item_id) > -1
    },
    pageCancel(page_modal) {
      this.page_modal = page_modal
    },
    handleSearch(val) {
      if (val) {
        this.theme_params.keyword = val
        this.search_phd = val.length > 10 ? val.substr(0, 9).concat('...') : val
        let index = this.$store.state.datahotsearchkey.findIndex((a) => a.position_id == '17')
        if (index > -1) {
          this.$store.state.datahotsearchkey[index].name = val
        }
        this.$store.commit('updateDatahotsearchkey', this.$store.state.datahotsearchkey)
      } else {
        this.search_ipt = this.default_key
        this.theme_params.keyword = this.default_key
      }
      this.theme_list = []
      this.theme_params.page = 1
      this.list_loading3 = true
      this.getThemeList()
    },
    handleClearOption() {
      this.theme_params = {
        theme_type_id: '',
        page: 1,
        keyword: '',
      }
      this.search_ipt = ''
      this.getThemeList()
      this.$router.push({ name: 'SpecialList', query: {} })
    },
    haddleClickScientific() {
      const { href } = this.$router.resolve({ name: 'Scientific' })
      window.open(href, '_blank')
    },
    haddleCloseScientific() {
      this.show_scientific = false
      localStorage.show_scientific = 1
    },
  },
  created() {
    this.search_phd = this.default_key
      ? this.default_key.length > 10
        ? this.default_key.substr(0, 9).concat('...')
        : this.default_key
      : '请输入关键字'
    if (this.active) {
      this.is_new = false
      this.theme_params.theme_type_id = this.active
      let type_item = this.theme_type_old.find((a) => a.id == this.active)
      this.show_kids.push(type_item.pid)
    }
    if (this.user_key) {
      this.getUserPayThemeType()
      this.show_scientific = localStorage.show_scientific ? false : true
    }
    this.getRecommendTheme()
    this.getThemeList()
    this.getAddPuv()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('options', 12)
      }
      window.onresize = () => {
        this.listenerScroll('options', 12)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.spe_list
  padding 30px 0
  width 1200px
  margin 0 auto
  prosition relative
  .theme-list
    display flex
    .classify
      flex 0 0 160px
      margin-right 20px
      .keyword-input
        position fixed
        top 94px
        width 160px
        padding-bottom 10px
        >>> .ivu-input-group
          display block
          position relative
          .ivu-input
            border 0
            background-color transparent
            box-shadow none
            font-weight normal
            padding 0 28px 0 0
            font-size 14px
            commonColor(#E9E9EB, #333333)
            height 30px
            padding-top 1px
            line-height 29px
            border-radius 0
            border-bottom 1px solid
            commonBorderColor(#525d89, #E9E9EB)
            box-sizing border-box
            &:focus
              border-color rgba(250, 122, 80, 1) !important
            &::-webkit-input-placeholder
              commonColor(#797B83, #999999)
            &::-moz-input-placeholder
              commonColor(#797B83, #999999)
            &:-ms-input-placeholder
              commonColor(#797B83, #999999)
          .ivu-input-group-append
            position absolute
            right 0
            top 6px
            height 18px
            width 18px
            box-sizing border-box
            border 0
            padding 0 !important
            background-color transparent !important
            commonColor(#797B83 !important, #999999 !important)
            border-radius 0
            &:before
              content none
            &.ivu-input-search i
              font-size 18px
            &:hover
              color rgba(250, 122, 80, 1) !important
      .options
        position fixed
        top 134px
        bottom 32px
        z-index 5
        width 160px
        overflow auto
        .classify-ul
          > li
            position relative
            commonBgColor(#1f2330, #FFFFFF)
            border-bottom 1px solid
            commonBorderColor(#2A2F42, #F3F3F3)
            > a
              display block
              line-height 22px
              font-size 14px
              commonColor(#E9E9EB, #666666)
              padding 14px 40px 14px 20px
              position relative
              .iconfont
                position absolute
                font-size 12px
                right 14px
                top 50%
                margin-top -11px
                cursor pointer
                commonColor(#797B83, #CCCCCC)
                font-weight normal !important
              &:hover
                color rgba(250, 122, 80, 1)
            &.active
              > a
                color #ffffff
                font-weight bold
                background rgba(250, 122, 80, 1)
                background linear-gradient(90deg, rgba(255, 183, 94, 1) 0%, rgba(244, 107, 69, 1) 100%)
                &:hover
                  color #fff
              .iconfont
                color #fff
                &:hover
                  color #fff
            &.show
              > a
                commonColor(#ffffff, #333333)
                font-weight bold
              .iconfont
                commonColor(#ffffff, #333333)
            .sec-ul
              border-top 1px solid
              commonBorderColor(#2A2F42, #F3F3F3)
              li
                a
                  display block
                  padding 14px 20px
                  line-height 22px
                  color #BCBDC1
                  commonColor(#BCBDC1, #666666)
                  font-size 14px
                  &:hover
                    color rgba(250, 122, 80, 1)
                &.active
                  > a
                    color #fff
                    font-weight bold
                    background rgba(250, 122, 80, 1)
                    background linear-gradient(90deg, rgba(255, 183, 94, 1) 0%, rgba(244, 107, 69, 1) 100%)
                    &:hover
                      color #fff
            .new
              display flex
              justify-content space-between
              align-items center
              padding 14px 10px 14px 20px
              span
                display block
                flex 1
              img
                height 20px
                cursor pointer
    .list
      flex auto
      position relative
      min-height 470px
      .list-top
        border-bottom 1px solid
        commonBorderColor(#40444F, #CCCCCC)
        padding-bottom 15px
        margin-bottom 20px
        display flex
        justify-content space-between
        .sel_clear
          line-height 24px
          span
            color rgba(250, 122, 80, 1)
            font-size 12px
            cursor pointer
            i.iconfont
              vertical-align top
              display inline-block
              font-size 12px
              margin-right 4px
            &:hover
              color #FC9C7C
      .scientific
        margin-bottom 20px
        width 100%
        position relative
        i
          position absolute
          font-size 18px
          color rgba(255, 255, 255, 1)
          opacity 0.8
          cursor pointer
          right 10px
          top 10px
          &:hover
            opacity 1
        img
          width 100%
          display block
          cursor pointer
      .s-tip
        font-size 22px
        commonColor(#E9E9EB, #333333)
        font-weight bold
        span
          margin 0 10px
          color rgba(250, 122, 80, 1)
          i
            margin 0 10px
            commonColor(#E9E9EB, #333333)
            font-style normal
      .pay-notes
        padding 20px
        commonBgColor(#1f2330, #FFFFFF)
        margin-bottom 20px
        position relative
        > i
          font-size 16px
          position absolute
          right 20px
          top 20px
          color rgba(250, 122, 80, 1)
          cursor pointer
          &:hover
            color #FC9C7C
          &.on
            transform rotate(180deg)
        > p
          commonColor(#E9E9EB, #333333)
          font-size 14px
          font-weight bold
          i
            font-weight normal
            color rgba(250, 122, 80, 1)
            font-size 14px
            inlineBlock()
            margin-right 4px
        .notes-cnt
          commonColor(#BCBDC1, #666666)
          font-size 12px
          line-height 20px
          margin 10px 0 -4px
      .spe_ul2
        li
          float left
          width 326px
          height 308px
          margin-bottom 20px
          margin-right 21px
          font-size 0
          commonBgColor(#1f2330, #FFFFFF)
          position relative
          transition_02s()
          cursor pointer
          > div
            width 326px
            height 308px
            position relative
            overflow hidden
          &:nth-of-type(3n)
            margin-right 0
          .logo
            width 326px
            height 204px
            position absolute
            top 0
            left 0
            z-index 2
            transition_02s()
            cursor pointer
            img
              width 326px
              height 204px
            img.r-tip
              position absolute
              right 0
              left auto
              bottom 0
              z-index 2
              width 24px
              height 24px
          .spe_info
            position absolute
            commonBgColor(#1f2330, #FFFFFF)
            padding 20px 24px
            width 326px
            top 204px
            z-index 3
            transition_02s()
            .p1
              font-size 18px
              line-height 24px
              height 48px
              commonColor(#e9e9eb, #333333)
              font-weight 600
              margin -3px 0
              ellipsisClamp2()
              cursor pointer
              &:hover
                color rgba(250, 122, 80, 1)
            .p2
              font-size 12px
              line-height 18px
              height 18px
              commonColor(#BCBDC1, #999999)
              margin-top 10px
              display -webkit-box
              overflow hidden
              text-overflow ellipsis
              word-break break-all
              -webkit-box-orient vertical
              -webkit-line-clamp 1
              transition_02s()
              span:first-of-type
                color rgba(250, 122, 80, 1)
                margin-right 21px
                position relative
                &:before
                  position absolute
                  content ''
                  height 11px
                  width 1px
                  commonBgColor(#40444F, #E9E9E9)
                  right -11px
                  top 1px
          .vip-sp
            position absolute
            top -5px
            left -5px
            z-index 2
            width 63px
            height 54px
          &:hover
            commonShadow(0 10px 30px 0 rgba(0, 0, 0, 0.9), 0px 10px 30px 0px rgba(121, 133, 143, 0.1))
            .logo, .spe_info
              transform translateY(-40px)
              .p2
                -webkit-line-clamp 3
                height 54px
      .list_bottom
        text-align center
        position relative
        .more_btn
          border 1px solid rgba(250, 122, 80, 1)
          border-radius 18px
          margin-top 10px
          display inline-block
          width 108px
          height 36px
          background transparent
          color rgba(250, 122, 80, 1)
          cursor pointer
          &:hover
            color #FC9C7C
            border-color #FC9C7C
      .no-tip
        font-size 14px
        commonColor(#bcbdc1, #999999)
        margin-top 40px
        text-align center
  .loading_bg
    height 470px
    position relative
  >>> .ivu-spin-fix .ivu-spin-main
    top 213px
</style>
